import React,{ useState, useEffect } from 'react';
import envConfig from '../../../config/env';
import happinessCheck from '../../sharecomponents/happinessCheck';

/*
*******************************************
add 20201218
qa區塊多了qa0ChtTitle變數 用來顯示header
modify NavMain 
-------------------------------------------
add  2021230 happinessCheck 幸福企業識別使用
*******************************************
*/
// const NavBar = (props) => {
//     return(
//         <div className="pearo-responsive-nav">
//             <div className="container">
//                 <div className="pearo-responsive-menu">
//                     <div className="logo text-left">
//                         <a href={props.logoURL}>
//                             <img src={props.logURL} alt="logo" />
//                             {props.logAutoNo>0 && <img className="logo-happiness" src="/image/happiness-pink.svg" alt="1111人力銀行" ></img> }
//                         </a>
//                     </div>
//                 </div>
//             </div>
//         </div>

//     );
// };

const NavMain = (props) => {
    const menuList = [
        { name: '公司介紹', link: '#company', enable: true },
        { name: '員工福利', link: '#benefit', enable: true },
        { name: '熱門職缺', link: '#jobs', enable: true },
        { name: '品牌介紹', link: '#brand', enable: true },
        { name: props.customizeName, link: '#custom', enable: props.customizeEnable },
        { name: props.qa0ChtTitle, link: '#faq', enable: props.qaEnable },
        { name: '聯絡我們', link: '#contact', enable: props.contactEnable }
    ]
    return (

        <div className="pearo-nav">
            <div className="container">
                <nav className="navbar navbar-expand-md navbar-light">                
                    <a className="navbar-brand" href={props.logoURL}>
                        <img src={props.logURL} alt="logo" />
                        {props.logAutoNo>0 && <img className="logo-happiness" src="/image/happiness-pink.svg" alt="1111人力銀行"></img> }
                    </a>
                    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                    </button>
                    <div className=" mean-menu collapse navbar-collapse" id="navbarSupportedContent">                      
                        <ul className="navbar-nav " >
                            {/* <li className="nav-item hidden-md-down"><div className="top-header-logo align-items-center mtb-17">
                                    <a href={props.logoURL}>
                                        <img src={props.logURL} alt="logo" />
                                        {props.logAutoNo>0 && <img className="logo-happiness" src="/image/happiness-pink.svg" alt="1111人力銀行" ></img> }
                                    </a>
                                </div>
                            </li> */}
                            {menuList.map((item, index) => {
                                return item.enable &&
                                    /* <li  key={index} className="nav-item">*/
                                    <li key={index} className={item.link==='#jobs'? 'nav-item job-display': 'nav-item'} data-toggle="collapse" data-target=".navbar-collapse.show">
                                       <a className="nav-link"  href={item.link}>{item.name}</a>
                                    </li>
                            })}
                        </ul>      
                    </div>
                </nav>
            </div>
        </div>

    )
}


function CustomerHeader(props) {
    const cid = props.match.params.cid;
    const [AutoNo, setAutoNo] = useState(0);
    useEffect(() => {
        happinessCheck(cid).then((happinessCheck)=>{
            var data=JSON.parse(happinessCheck);
            // console.log(data.msg)
            // console.log(data.autono)
            if(data.msg==='Nice'){
                setAutoNo(data.autono)
            }
        })
        // 使用瀏覽器 API 更新文件標題
        //setAutoNo(envConfig.AutoNoLimit)
      });

    const { customizeData } = props.customizeReducer;
    const { qaData } = props.qaReducer;
    const { contactData} = props.contactReducer;
    const { data } = props.datatableReducer;
    
    let logURL = "/image/logo-1111.png";
    let logoURL = "https://1111.com.tw";

    if(data && data.length > 0){
        logURL = `${envConfig.WebAPI}/image/${cid}?fileName=${data[0].logoImg}`;
        logoURL = `https://www.1111.com.tw/corp/${cid}/`;
    }

    let customizeEnable;
    let customizeName;
    if(customizeData && customizeData.length > 0){
        customizeData.forEach(element => {
            customizeEnable =  element.customizeEnable;
            customizeName = element.customizeName;
        })
    }

    let qaEnable;
    let qa0ChtTitle="常見問題";
    if(qaData && qaData.length > 0){
        qaData.forEach(element => {
            qaEnable =  element.qaEnable;
            qa0ChtTitle=element.qa0ChtTitle===null || element.qa0ChtTitle.trimStart()==="" ? "常見問題":element.qa0ChtTitle;
        })
    }

    let contactEnable;
    if(contactData && contactData.length > 0){
        contactData.forEach(element => {
            contactEnable =  element.contactEnable;
        })
    }

    return (
        <header className="header-area header-style-three">
            <div className="navbar-area">
                {/* <NavBar logURL={logURL} logoURL={logoURL} logAutoNo={AutoNo}/> */}
                <NavMain logURL={logURL} logoURL={logoURL} logAutoNo={AutoNo} customizeEnable={customizeEnable} customizeName={customizeName} qaEnable={qaEnable} contactEnable={contactEnable} qa0ChtTitle={qa0ChtTitle}/>
                
            </div>
        </header>                
    );


}



export default CustomerHeader;